import React from 'react';
import './App.css';
import AppRoutes from './routes/index'
import { ConfigProvider } from 'antd';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { GlobalProvider } from './GlobalContext';

function App() {
  return (
    <div className='App'>
      <ConfigProvider
        theme={{
          token: {
            // Seed Token
            colorPrimary: 'rgba(33,33,37,0.7)',
            borderRadius: 2,

            // Alias Token
            colorBgContainer: '#f6ffed',
          },
        }}
      >   
        <GlobalProvider>
          <AppRoutes/>
        </GlobalProvider>
      </ConfigProvider>
    </div>
  );
}

export default App;
